import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const navLinks = [
    { name: 'FLEET', path: '/planes' },
    { name: 'DESTINATIONS', path: '/destinations' },
    { name: 'WHY YESJETS', path: '/why-yesjets' },
    { name: 'TIME VALUE', path: '/time-value' },
    { name: 'ABOUT', path: '/about' },
    { name: 'CONTACT', path: '/contact' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || menuOpen ? 'bg-black shadow-lg' : 'bg-black/40'}`}>
      <div className="mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/fba74845-563a-49c7-acaf-7a827f8044ac.png"
              alt="YESJETS Logo"
              className="h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Links */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-sans tracking-widest transition-colors cursor-pointer whitespace-nowrap ${location.pathname === link.path ? 'text-gold' : 'text-white hover:text-gold'}`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/booking"
              className="px-6 py-2 border-2 border-gold text-gold rounded-full text-sm font-sans tracking-wider hover:bg-gold hover:text-black transition-all cursor-pointer whitespace-nowrap"
            >
              BOOK NOW
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-white/10 flex flex-col gap-4 pt-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-sans tracking-widest transition-colors cursor-pointer ${location.pathname === link.path ? 'text-gold' : 'text-white hover:text-gold'}`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/booking"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-gold text-gold rounded-full text-sm font-sans tracking-wider hover:bg-gold hover:text-black transition-all cursor-pointer whitespace-nowrap mt-2"
            >
              BOOK NOW
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
